<template>
  <div class="publicStatic">
    <div>
      <el-row :gutter="12" type="flex" class="row-bg" justify="space-around" style="margin-bottom: 10px;">
        <el-col :span="4">
          <el-input size="mini" placeholder="请输入关键字" v-model="form.key" style="margin-right: 6px;"></el-input>
        </el-col>
        <el-col :span="8">
          <el-date-picker style="margin-right: 6px;" v-model="dateTime" type="daterange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" size="mini" value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']" :clearable="false">
          </el-date-picker>
        </el-col>
        <el-col :span="12">
          <div style="display: flex;align-items: center;">
            <el-button @click="searchData" size="mini" type="primary" icon="el-icon-search">查询</el-button>
            <el-button @click="reset" size="mini" type="primary" icon="el-icon-search">重置</el-button>
            <el-button @click="exportData" size="mini" type="primary">导出</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-table :data="tableData" style="width: 100%;height: 100%;" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column label="序号" type="index" width="100" align="center" />
          <el-table-column prop="title" label="出差报告" align="center" />
          <el-table-column prop="createTime" label="时间" align="center" />
          <el-table-column prop="deptName" label="所属部门" align="center" />
          <el-table-column prop="createName" label="出差人员" align="center" />
          <el-table-column prop="reportSubmitStatus" label="报告时效" align="center" />

          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="viewDetail(scope.row)">查看</el-button>
              <el-button size="mini" type="text" @click="downPdf(scope.row)">导出报告</el-button>
              <el-button size="mini" type="text" @click="exports(scope.row)">导出考核</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="display: flex;justify-content: center;margin-top: 10px;">
          <el-pagination background layout="prev, pager, next" :total="total" @current-change="checkPage">
          </el-pagination>
        </div>
      </el-row>
      <el-dialog title="查看考核" width="1000px" :visible.sync="dialogUploadVisible">
        <el-card id="form" shadow="never">
          <el-form :model="formData" label-width="130px" ref="form" size="mini">
          <div>
            <el-form-item label="姓名：" prop="createName" style="font-weight: 600;">
              <el-input v-model="formData.createName" style="width: 300px;"></el-input>
            </el-form-item>
            <el-form-item label="公司-部门：" prop="deptName" style="font-weight: 600;">
              <el-input v-model="formData.deptName" style="width: 300px;"></el-input>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="标题：" prop="title" style="font-weight: 600;">
                  <el-input v-model="formData.title" style="width: 300px;"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="流水号：" prop="serialNo" style="font-weight: 600;">
                  <el-input v-model="formData.serialNo" style="width: 300px;"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="提交人：" prop="createName" style="font-weight: 600;">
                  <el-input v-model="formData.createName" style="width: 300px;"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="所属部门：" prop="deptName" style="font-weight: 600;">
                  <el-input v-model="formData.deptName" style="width: 300px;"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="申请日期：" prop="createTime" style="font-weight: 600;">
                  <el-input v-model="formData.createTime" style="width: 300px;"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="紧急程度：" prop="urgency" style="font-weight: 600;">
                  <el-input v-model="formData.urgency" style="width: 300px;"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="直接上级：" prop="superior" style="font-weight: 600;">
              <el-input v-model="formData.superior"></el-input>
            </el-form-item>
            <div style="text-align: center; margin: 10px 0;">
              请填写出差开始时间和结束时间，系统会自动核算出差天数；如与实际情况不符，请进行修改
            </div>
            <el-form-item label="出差信息：" prop="askerName" style="font-weight: 600;">
              <el-table :data="formData.timeLineList" :border="true" style="width: 100%;height: 100%;">
                <el-table-column prop="address" label="出差地点" align="center" />
                <el-table-column prop="startTime" label="开始时间" align="center" />
                <el-table-column prop="endTime" label="结束时间" align="center" />
                <el-table-column prop="count" label="出差天数" align="center" />
              </el-table>
            </el-form-item>
            <el-form-item label="出差总天数：" style="font-weight: 600;">
              {{ zts }}天
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="经费限额：" prop="costLimit" style="font-weight: 600;">
                  <el-input v-model="formData.costLimit" style="width: 300px;"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="项目名称：" prop="projectName" style="font-weight: 600;">
                  <el-input v-model="formData.projectName" style="width: 300px;"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="项目经理：" prop="projectManager" style="font-weight: 600;">
              <el-input v-model="formData.projectManager"></el-input>
            </el-form-item>
            <el-form-item label="结果标的及投入情况：" prop="investInfo" style="font-weight: 600;">
              <el-input v-model="formData.investInfo" autosize type="textarea"></el-input>
            </el-form-item>
            <el-form-item label="感动客户目标：" prop="target" style="font-weight: 600;">
              <el-input v-model="formData.target" autosize type="textarea"></el-input>
            </el-form-item>
            <el-form-item label="投入产出分析：" prop="inOutAnalysis" style="font-weight: 600;">
              <el-input v-model="formData.inOutAnalysis" autosize type="textarea"></el-input>
            </el-form-item>
            <el-form-item label="行程规划：" prop="tripPlan" style="font-weight: 600;">
              <el-input v-model="formData.tripPlan" autosize type="textarea"></el-input>
            </el-form-item>
            <el-form-item label="附件（车票、飞机票等比价截图）：" prop="annex" style="font-weight: 600;">
              <el-input v-model="formData.annex"></el-input>
            </el-form-item>
            <el-form-item label="出差完成详细内容：" prop="completeContent" style="font-weight: 600;">
              <el-input v-model="formData.completeContent" autosize type="textarea"></el-input>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="实用时间：" prop="practicalTime" style="font-weight: 600;">
                  <el-input v-model="formData.practicalTime" style="width: 300px;"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="实用经费：" prop="practicalCost" style="font-weight: 600;">
                  <el-input v-model="formData.practicalCost" style="width: 300px;"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="本次出差投入产出完成情况：" prop="completeSituation" style="font-weight: 600;">
              <el-input v-model="formData.completeSituation" autosize type="textarea"></el-input>
            </el-form-item>
            <el-form-item label="下步计划投入产出分析：" prop="inputAnalysis" style="font-weight: 600;">
              <el-input v-model="formData.inputAnalysis" autosize type="textarea"></el-input>
            </el-form-item>
            <el-form-item label="出差报告：" prop="report" style="font-weight: 600;">
              <el-input v-model="formData.report"></el-input>
            </el-form-item>
            <el-form-item label="自我鉴定：" prop="selfIdentification" style="font-weight: 600;">
              <el-input v-model="formData.selfIdentification" autosize type="textarea"></el-input>
            </el-form-item>
            <div style="text-align: center; margin: 10px 0;">
              1、本任务书要求回来后12小时内交负责人，否则按违规处理；

              2、如果任务简单能说明问题，完成此表即可，否则附加出差报告
            </div>
            <el-form-item label="签字意见：" prop="signSuggest" style="font-weight: 600;">
              <el-input v-model="formData.signSuggest"></el-input>
            </el-form-item>
            <el-form-item label="时效合规判断：" prop="reportSubmitStatus" style="font-weight: 600;">
              <el-input v-model="formData.reportSubmitStatus"></el-input>
            </el-form-item>
          </div>
        </el-form>
        </el-card>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { businessList, expUserList, businessConfig, exportExcel } from "@/api/dayqing";
import moment from "moment";
import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";
export default {
  name: "ResultStatic",
  data() {
    return {
      form: {
        key: "",
        beginTime: "",
        endTime: ""
      },
      formData: {},
      formUpload: {
        title: '',
        thingsList: [
          {
            tianjiashixiang: '',
            personList: [
              {
                content: '你好',
                date: ''
              }
            ]
          }
        ]
      },
      dateTime: [],
      dateType: "yesterDay",
      tableData: [],
      tableDataPerson: [],
      multipleSelection: [],
      zts: '',
      pageType: {
        pageNum: 1,
        pageSize: 10
      },
      total: undefined,
      dialogUploadVisible: false,

    };
  },
  mounted() {
    this.initParam()
    this.getuserList();
  },
  methods: {
    searchData() {
      this.getuserList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    async getuserList() {
      this.form.beginTime = this.dateTime[0];
      this.form.endTime = this.dateTime[1];
      const { code, data, total } = await businessList({
        ...this.form,
        ...this.pageType
      });
      if (code != 0) return;
      this.tableData = data.rows;
      this.total = total;
    },
    checkPage(val) {
      this.pageType.pageNum = val;
      this.getuserList();
    },
    exportData() {
      const item = {
        ids: []
      }
      const arr = []
      this.multipleSelection.map(item => {
        arr.push(item.id)
      })
      if(arr == null || arr.length == 0) {
        this.$message.warning("请选择要导出的报告");
        return
      }
      item.ids = arr.join(",")
      exportExcel(item).then(res => {
        const blob = new Blob([res.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("id", "pdfID");
        link.setAttribute("download", `出差报告.xls`);
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 0);
      });
    },
    addThings() {
      this.formUpload.thingsList.push({})
    },
    addPerson(index) {
      this.formUpload.thingsList[index].personList.push({
        content: '你好',
        date: ''
      })
    },
    async downPdf(row) {
      this.dialogUploadVisible = true
      const { data } = await businessConfig(row.id)
      this.formData = data
      this.formData.timeLineList.map(item => {
        this.zts += item.count
      })
      setTimeout(() => {
        let _this = this
        document.documentElement.scrollTop = 0
        let canvas = document.createElement("canvas") // 生成canvas上下文
        let context = canvas.getContext("2d")
        let _articleHtml = document.getElementById('form')
        let _w = _articleHtml.clientWidth //获取需要导出pdf区域的宽度和高度
        let _h = _articleHtml.clientHeight
        let scale = 3  // 将画布宽&& 高放大三倍，提高清晰度
        if (_w > _h) {
          _h = _w
        }
        canvas.width = _w * scale
        canvas.height = _h * scale
        context.scale(scale, scale)
        let opts = {
          scale: 1,
          width: _w,//dom 原始宽度
          height: _h,
          canvas: canvas,
          useCORS: true  //允许canvas画布内可以跨域请求外部链接图片, 允许跨域请求。
        }
        // 以上部分都是为了强化清晰度的，放大canvas画布
        html2canvas(_articleHtml, opts).then(canvas => {
          console.log(canvas, scale);
          _this.createPdfAll(canvas, scale)
        })
      }, 1000)

    },
    createPdfAll(canvas, scale) {
      let contentWidth = canvas.width / scale
      let contentHeight = canvas.height / scale
      console.log(this);
      let pdf = new jsPDF('', 'pt', [contentWidth, contentHeight])  //自定义宽高
      let pageData = canvas.toDataURL('image/jpeg', 1.0) //转换图片为dataURL
      pdf.addImage(pageData, 'JPEG', 0, 0, contentWidth, contentHeight) //添加图像到页面
      pdf.save(`${this.formData.title}.pdf`)
      this.dialogUploadVisible = false
    },
    async viewDetail(row) {
      const { data } = await businessConfig(row.id)
      this.formData = data
      this.formData.timeLineList.map(item => {
        this.zts += item.count
      })
      this.dialogUploadVisible = true
    },
    exports(row) {
      const item = {
        ids: row.id
      }
      // var item = new FormData()
      // item.append("ids",row.id)
      exportExcel(item).then(res => {
        const blob = new Blob([res.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("id", "pdfID");
        link.setAttribute("download", `${row.title}.xls`);
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 0);
      });
    },
    // 重置
    reset() {
      this.initParam()
      this.getuserList();
    },
    // 初始化参数
    initParam() {
      this.dateTime =  [
          moment()
            .subtract(6, "days")
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss"),
          moment()
            .subtract(0, "days")
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss")
        ]
        this.form = {}
        this. pageType = {
          pageNum: 1,
          pageSize: 10
        }
      }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/BusinessReport/HomePage.vue